import { render, staticRenderFns } from "./Exclusoes.vue?vue&type=template&id=2370c35f&scoped=true"
import script from "./Exclusoes.vue?vue&type=script&lang=js"
export * from "./Exclusoes.vue?vue&type=script&lang=js"
import style0 from "./Exclusoes.vue?vue&type=style&index=0&id=2370c35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370c35f",
  null
  
)

export default component.exports